module.exports = __webpack_public_path__ + "img/no-access.bfc8ee29.svg";